// removed by extract-text-webpack-plugin
module.exports = {"empty":"_1lXaDzlZnRwNf8XtnxDB5","article":"_1ERC_37knKsMEXu0lI3W92","share":"_2jIkecYcZU_ahikoHVaOIH","articleBody":"_26xXPj9IboW-Bss0UjUgui","date":"_3IYcVffbCjYQ7uc44bF3yV","content":"NCSVw-PANukfba3dgD72a","image":"_1DYFoi6EdYdBUxR7b1XvM","author":"eCcdkInyxrmIcgOoK4_gM","nextPrevWrap":"_1IH7Z5hWGYkbfEUKCO3RNK","nextPrevWrapSingle":"_3QEcAqVWPJTsdTPtbFnj3p","nextPrev":"_17eX4vxjgkrN8JmTLjRZ6m","contentPreloader":"Po03I8hL95rDTDUsVe5Xz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Credits/Articles.scss
// module id = 3038
// module chunks = 0